var React = require('react');

function Menu2025 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 1.56616H16","stroke":"black","strokeWidth":"1.6","key":0}),React.createElement("path",{"d":"M0 8.5H16","stroke":"black","strokeWidth":"1.6","key":1}),React.createElement("path",{"d":"M0 15.4339H16","stroke":"black","strokeWidth":"1.6","key":2})]);
}

Menu2025.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Menu2025;

Menu2025.default = Menu2025;
